import React from "react";
import { useLocation } from "react-router-dom";
import VendorSelection from "./VendorSelection";
import RateAnalysisVendorPage from "./RateAnalysisVendorPage";
import InvalidVendor from "./InvalidVendor";
import { getVendorFromPath } from "./vendorData";

const RateAnalysisPage = () => {
  const location = useLocation();
  const vendor = getVendorFromPath(location.pathname);

  if (location.pathname.includes("/rate-analysis/")) {
    if (!vendor) {
      return <InvalidVendor />;
    }
    return <RateAnalysisVendorPage vendor={vendor} />;
  }

  return <VendorSelection />;
};

export default RateAnalysisPage;
